<template>
      <Page :title="title">
            <div class="clientsDetail"  ref="scrollView">
                  <!-- 客户这个人信息展示 -->
                  <div class="clients-information">
                        <div class="clients-information-header">
                              <img
                                    :src="basicList.custBasicInfo.headUrl?basicList.custBasicInfo.headUrl:basicList.custBasicInfo.sex==0?require('@/assets/MM.png'):require('@/assets/WW.png')"
                                    alt=""
                                    class="headerImg"
                                    srcset=""
                              >
                              <!-- VIP -->
                              <img class="vipImg"   v-if="basicList.custBasicInfo.member=='10'" :src="require('@/assets/img/v.png')" alt="">
                              <!--  姓名  电话 VIP登记 时间  -->
                              <div class="information-list">
                                    <div class="clientName">
                                         {{basicList.custBasicInfo.custName||''}}
                                    </div>
                                    <div class="phone">
                                          <img
                                                :src="require('@/assets/img/phone.png')"
                                                class="phoneImg"
                                                alt=""
                                                srcset=""
                                          >
                                          <div class="phone-numer">{{basicList.custBasicInfo.mobile||''}}</div>
                                          <a :href="'tel:'+basicList.custBasicInfo.mobile"  class="telPhoneA" >
                                             <img :src="require('@/assets/telPhone.png')"  class="telPhone"  alt="">
                                          </a>
                                    </div>
                                    <div class="Vip-flex" >
                                          <div>VIP等级：</div>
                                          <div class="VIP-starts" :style="'width:'+VipNum*.4+'rem'">
                                                <img
                                                      v-for="(item,index) in VipNum"
                                                      v-bind:key="index"
                                                      :src="require('@/assets/img/vipStar.png')"
                                                      class="start"
                                                      alt=""
                                                      srcset=""
                                                >
                                          </div>
                                          <div class="month" v-if="timeM!=''">（{{timeM}}个月）</div>
                                    </div>
                              </div>
                        </div>
                        <!-- 标签栏 -->
                        <div class="label-list">
                              <div
                                    v-for="(item,index)   in  label"
                                    :class="item.edit==false?'label-title':'label-title-active'"
                                    v-bind:key="index"
                                    @click="addLabel(item.edit)"
                              >{{item.name}}</div>
                        </div>
                  </div>
                  <!-- 展示栏信息列表 -->
                  <div class="clients-informationLists">
                        <div class="messageList-header">
                              <div
                                    v-for="(item,index)  in  messageList "
                                    class="messageList-item"
                                    v-bind:key="index"
                                    @click="showMessageList(index)"
                              >
                                    <img :src="item.edit==false?item.img:item.imges" alt="">
                                    <div class="infos" v-if="item.code!=0">{{item.code}}</div>
                                    <div>{{item.name}}</div>
                              </div>
                        </div>
                        <!-- 根据筛选  展示不能信息组件 -->
                        <div>
                              <basicIf :data="basicList"  v-show="listIndex==0"  :custId="this.custId"  :hasModifyAuth="hasModifyAuth"   ref="basicIf" />
                              <Inproduct    v-show="listIndex==1"  :custId="this.custId"  ref="Inproduct" />
                              <ByProduct    v-show="listIndex==2"  :custId="this.custId"  ref="ByProduct"  />
                              <FwNews       v-show="listIndex==3"  :custId="this.custId"  ref="FwNews"/>
                              <JnActivity   v-show="listIndex==4"  :custId="this.custId"  ref="JnActivity" />
                              <JnCurriculum v-show="listIndex==5"  :custId="this.custId"  ref="JnCurriculum" />
                              <TheRecords   v-show="listIndex==6"  :custId="this.custId"  ref="TheRecords" />
                              <repairHis    v-show="listIndex==7"  :custId="this.custId"  ref="repairHis"  />
                        </div>

                        <!-- 最近信息  系统信息 -->
                        <div>
                               <!-- 基本信息 -->
                            <div class="basic-information">
                              <div class="basic-information-title">最近信息</div>
                              <div class="redactImg"></div>
                            </div>
                            <div class="basic-information-flex" v-if="basicList.latelyInfo">
                              <ul class="basic-information-lists">
                                <li>
                                  <div class="basic-information-lists-item">消费门店</div>
                                  <div class="basic-information-lists-text">{{basicList.latelyInfo.deptName||''}}</div>
                                </li>
                                <li>
                                  <div class="basic-information-lists-item">购买时间</div>
                                  <div class="basic-information-lists-text">{{basicList.latelyInfo.buyDate||''}}</div>
                                </li>
                                <li>
                                  <div class="basic-information-lists-item">参与活动</div>
                                  <div class="basic-information-lists-text">{{basicList.latelyInfo.campName||''}}</div>
                                </li>
                                <li>
                                  <div class="basic-information-lists-item">参与课程</div>
                                  <div class="basic-information-lists-text">{{basicList.latelyInfo.courseName||''}}</div>
                                </li>
                                <li>
                                  <div class="basic-information-lists-item">消费金额</div>
                                  <div class="basic-information-lists-text">{{basicList.latelyInfo.amount?$numeral(basicList.latelyInfo.amount).format('0,0.00'):""}}</div>
                                </li>
                                <li>
                                  <div class="basic-information-lists-item">联系日期</div>
                                  <div class="basic-information-lists-text">{{basicList.latelyInfo.followDate?basicList.latelyInfo.followDate.split(" ")[0]:''}}</div>
                                </li>
                              </ul>
                            </div>

                            <div class="basic-information">
                              <div class="basic-information-title">系统信息</div>
                              <div class="redactImg"></div>
                            </div>
                            <div class="basic-information-flex" v-if="basicList.systemInfo">
                              <ul class="basic-information-lists">
                                <li>
                                  <div class="basic-information-lists-item">销售顾问</div>
                                  <div class="basic-information-lists-text">{{basicList.systemInfo.createUserName||''}}</div>
                                </li>
                                <li>
                                  <div class="basic-information-lists-item">所属门店</div>
                                  <div class="basic-information-lists-text">{{basicList.systemInfo.createDeptName||''}}</div>
                                </li>
                                <li>
                                  <div class="basic-information-lists-item">修改人</div>
                                  <div class="basic-information-lists-text">{{basicList.systemInfo.modifyUserName||''}}</div>
                                </li>
                                <li>
                                  <div class="basic-information-lists-item">修改门店</div>
                                  <div class="basic-information-lists-text">{{basicList.systemInfo.modifyDeptName||''}}</div>
                                </li>
                                <li>
                                  <div class="basic-information-lists-item">创建时间</div>
                                  <div class="basic-information-lists-text">{{basicList.systemInfo.createTime?basicList.systemInfo.createTime:''}}</div>
                                </li>
                                <li>
                                  <div class="basic-information-lists-item">最近修改时间</div>
                                  <div class="basic-information-lists-text">{{basicList.systemInfo.modifyTime?basicList.systemInfo.modifyTime:''}}</div>
                                </li>
                                <li>
                                  <div class="basic-information-lists-item">群id</div>
                                  <div class="basic-information-lists-text">{{chatId}}</div>
                                </li>
                              </ul>
                            </div>

                        </div>

                  </div>
                  <!-- 弹出层 -->
                  <van-popup v-model="labelShow">
                        <div class="label-models">
                              <!-- 标题  -->
                              <div class="label-model-title">
                                    <div class="label-model-titles">选择客户标签</div>
                                    <div class="select-label-hint">提示：单击选择，再次点击取消。</div>
                              </div>
                              <div class="label-list-flex-itemAuto">
                              <div  v-for="(items,index) in selectLabel"  v-bind:key="index" >
                              <!-- 标题 -->
                              <div class="basic-label-title">{{items.typeName}}</div>
                              <!-- 标签展示内容列表 -->
                              <div class="label-list-flex-item">
                                    <div class="label-list-flex">
                                          <div
                                                v-for="(item,index) in items.tagList"
                                                v-bind:key="index"
                                                class="select-labels-title"
                                                @click="clickLabels(index,item)"
                                                :style="'background:'+item.background"
                                          >{{item.name}}</div>
                                    </div>
                              </div>
                              </div>
                              </div>
                              <!-- 确定取消 -->
                              <div class="confirm-cancel">
                                    <div class="button-flex-color flex-border-button">
                                          <div class="button-flex-item" @click="cancelLabel">取消</div>
                                    </div>
                                    <div class="button-flex-color">
                                          <div
                                                class="button-flex-item button-active"
                                                @click="confirmLabel"
                                          >确定</div>
                                    </div>
                              </div>
                        </div>
                  </van-popup>
            </div>
      </Page>
</template>




<script>
import basicIf   from "./childCompoents/basicInformation.vue";   //基本信息
import Inproduct from "./childCompoents/IntentionProduct.vue";   //意向产品
import ByProduct from "./childCompoents/buyProduct.vue";         //购买产品
import FwNews    from "./childCompoents/followNews.vue";         //跟进信息
import JnActivity from "./childCompoents/joinActivity.vue";      //参与活动
import JnCurriculum from "./childCompoents/joinCurriculum.vue"   //参与课程
import TheRecords   from "./childCompoents/theRecords.vue"       //问卷记录
import repairHis   from "./childCompoents/repairHis.vue"       //问卷记录
import {differenceInMonths} from  'date-fns';

export default {
  data() {
    return {
      title: "客户详情",
      VipNum: 0, //VIP 等级
      listIndex:0,
      custId:"", //客户ID
      label: [], // 标签列表
      selectLabel: [
        // 选择标签列表
        { name: "微信会员", edit: false, background: "#373737" },
        { name: "入门基础课程", edit: false, background: "#373737" },
        { name: "微信会员", edit: false, background: "#373737" },
        { name: "入门", edit: false, background: "#373737" },
        { name: "微信会员", edit: false, background: "#373737" },
        { name: "入门基础课程", edit: false, background: "#373737" },
        { name: "微信会员", edit: false, background: "#373737" },
        { name: "入门基础课程", edit: false, background: "#373737" },
        { name: "微信会员", edit: false, background: "#373737" },
        { name: "入门基础课程", edit: false, background: "#373737" },
        { name: "微信会员", edit: false, background: "#373737" },
        { name: "入门基础课程", edit: false, background: "#373737" },
        { name: "微信会员", edit: false, background: "#373737" },
        { name: "入门基础课程", edit: false, background: "#373737" },
        { name: "微信会员", edit: false, background: "#373737" },
        { name: "入门基础课程", edit: false, background: "#373737" },
        { name: "微信会员", edit: false, background: "#373737" },
        { name: "入门基础课程", edit: false, background: "#373737" }
      ],
      labelShow: false, // 标签展示
      messageList: [
        {
          name: "基本信息",
          img: require("@/assets/course/information.png"),
          imges:require("@/assets/course/information1.png"),
          edit:true,
          val: 1,
          code:0
        },
        {
          name: "意向产品",
          img: require("@/assets/course/InProduct.png"),
          imges:require("@/assets/course/InProduct1.png"),
          val: 2,
          edit:false,
          code:0
        },
        {
          name: "购买产品",
          img: require("@/assets/course/ByProduct.png"),
          imges:require("@/assets/course/ByProduct1.png"),
          val: 3,
          edit:false,
          code:0
        },
        {
          name: "跟进信息",
          img: require("@/assets/course/followIn.png"),
          imges:require("@/assets/course/followIn1.png"),
          val: 4,
          edit:false,
          code:0
        },
        {
          name: "参与活动",
          img: require("@/assets/course/activity.png"),
          imges:require("@/assets/course/activity1.png"),
          val: 5,
          edit:false,
          code:0
        },
        {
          name: "参与课程",
          img: require("@/assets/course/course.png"),
          imges:require("@/assets/course/course1.png"),
          val: 6,
          edit:false,
          code:0
        },
        {
          name: "问卷记录",
          img: require("@/assets/course/questionnaire.png"),
          imges:require("@/assets/course/questionnaire1.png"),
          val: 7,
          edit:false,
          code:0
        },
        {
          name: "维修记录",
          img: require("@/assets/cust/repairHis.png"),
          imges:require("@/assets/cust/repairHisSelected.png"),
          val: 8,
          edit:false,
          code:0
        }
      ],
      // 基本信息
      basicList: {
        custBasicInfo:{},  //基本信息
        systemInfo:{},  //系统新
        latelyInfo:{},  //最近信息
        assetList:[],   //相机集合
      },
      pitchList:[],  // 选中列表
      pitchLists:[], // 选后 选中列表存在选项
      deleteList:[], // 删除列表
      timeM:"",      // 入会员月份
      IdCode:"",     // 客户菜单ID
      hasModifyAuth : true, //是否有修改客户的权限
      chatId:''
    };
  },
  methods: {
    /**
     *  添加标签
     *  @param {Boolean}  val
     */
    addLabel(val) {
      if (val) {
        this.labelShow = true;
        this.getTagAlls();
      }
    },
    /**
     *  单机点击标签
     *  @param {Number}  index
     *  @param {Boolean}  val
     **/
    clickLabels(index, val) {
        let $list = [];$list = this.selectLabel;
      if (val.edit) {
        $list[val.index]['tagList'][index]["edit"] = false;
        $list[val.index]['tagList'][index]["background"] = "#373737";
        this.selectLabel = $list;
        let $index_   =   this.pitchLists.indexOf(val.id);
        this.pitchLists.splice($index_,1)
      } else {
        $list[val.index]['tagList'][index]["edit"] = true;
        $list[val.index]['tagList'][index]["background"] = "#E51C23";
        this.selectLabel = $list;
        this.pitchLists.push(val.id);
      }
    },
    /**
     *   确定取消
     *
     **/

    cancelLabel() {
      let $list = [];
      $list = this.selectLabel;
      for (let i = 0; i < $list.length; i++) {
        $list[i]["edit"] = false;
        $list[i]["background"] = "#373737";
      }
      this.selectLabel = $list;
      this.labelShow = false;
      this.pitchLists=[];
      this.pitchList=[];
    },
    confirmLabel() {
      let $list = [],$activeLabel = [],$delete=[]

      /***
       *  对比已选中的数组  和提交的数组  已删除的数组选项
       */
    for(let k=0;k<this.selectLabel.length;k++){
      let $tag  = this.selectLabel[k]['tagList'];
         if($tag){
                for(let g=0;g<$tag.length;g++){
                      if($tag[g]['type']==1&&$tag[g]['edit']==false){
                            $delete.push($tag[g]['id'])
                      }
                      if($tag[g]['edit']==true){
                            $activeLabel.push($tag[g]['id'])
                      }
                }
         }
    }
      this.setSaveTag($delete.join(","),$activeLabel.join(","))
    },
    /**
     *
     *  点击列表切换
     *
     */
    showMessageList(index){
      this.listActive(index);
        if(index>=0){
          this.listIndex=index
          switch(index){
            case 0  : this.$refs.basicIf.getCustId(this.custId);break
            case 1  : this.$refs.Inproduct.custListIntentionProd(this.custId);break
            case 2  : this.$refs.ByProduct.getCustListSoldProd(this.custId);break
            case 3  : this.$refs.FwNews.getCustListFollow(this.custId);break
            case 4  : this.$refs.JnActivity.joinActivityList(this.custId);break
            case 5  : this.$refs.JnCurriculum.joinCurriculumList(this.custId);break
            case 6  : this.$refs.TheRecords.getCustListSurvey(this.custId);break
            case 7  : this.$refs.repairHis.queryList(this.custId);break
          }
        }
    },
    /**
     *
     * 列表切换状态
     *
     */
    listActive(index){
      this.messageList[index]['edit']=true;
      for(let i=0;i<this.messageList.length;i++){
        if(i>index||i<index){
          this.messageList[i]['edit']=false;
        }
      }
    },
    /**
     *
     *
     *  客户详情接口
     *  @param {String}  salesId
     *  @param {String}  custId
     *
     */
    getCustDetail(custId){
      this.$api.getCustDetail({salesId:this.$wxuserUtil.getUserId(),custId:custId}).then(Response=>{
          if(Response.success==true){
            this.basicList['custBasicInfo']=Response.data.custBasicInfo||{}; //基本信息
            this.basicList['latelyInfo']   =Response.data.latelyInfo||{};    //最近信息
            this.basicList['systemInfo']   =Response.data.systemInfo||{};    //系统信息
            this.basicList['assetList']    =Response.data.custBasicInfo||[]; //相机列表
            this.updateTitleNum(Response.data.relaCnt)
            var date      =  new Date();
            var year      =  date.getFullYear();
            var month     =  date.getMonth();
            var day       =  date.getDay();
          if(Response.data.custBasicInfo.vipLevel){
            this.VipNum=Response.data.custBasicInfo.vipLevel?parseInt(Response.data.custBasicInfo.vipLevel/10):0
          }
        if(Response.data.custBasicInfo.registerDate){
            var s1 = Response.data.custBasicInfo.registerDate.split(" ")[0].replace(/-/g, "/");var s2="";
            s1 = new Date(s1.replace(/-/g, "/"));
            s2 = new Date();//当前日期：2017-04-24
            var days = s2.getTime() - s1.getTime();
            var time = parseInt(days / (1000 * 60 * 60 * 24))/30;
            this.timeM=parseInt(time)?parseInt(time):parseInt(time)<30?1:'';
          }
          }else{
            this.timeM="";
          }
          try{
          this.$refs.basicIf.getCustId(custId);
          this.$refs.JnCurriculum.joinCurriculumList(custId);
          this.$refs.TheRecords.getCustListSurvey(custId);
          this.$refs.JnActivity.joinActivityList(custId);
          this.$refs.Inproduct.custListIntentionProd(custId);
          this.$refs.FwNews.getCustListFollow(custId);
          this.$refs.FwNews.getExUserId(Response.data.userExId);
          this.$refs.ByProduct.getCustListSoldProd(custId);
          }catch(e){}
      })
    },
    /**
     *
     * 更新标题栏数量展示
     *
     */
    updateTitleNum(DATA){
               console.log("传入的数组1",DATA)
         if(typeof DATA=="object"){
               this.messageList[1]['code']=DATA['leadCnt']
               this.messageList[2]['code']=DATA['purchaseRecordCnt']
               this.messageList[3]['code']=DATA['followCnt']
               this.messageList[4]['code']=DATA['campaignCnt']
               this.messageList[5]['code']=DATA['courseCnt']
               this.messageList[6]['code']=DATA['surveyCnt']
               this.messageList[7]['code']=DATA['repairHisCnt']
         }
    },
    /**
     *
     *
     * 客户全部标签
     *
     */
    getTagAlls(){
      this.$api.getTagAlls({salesId:this.$wxuserUtil.getUserId()}).then(Response=>{
          this.selectLabel=this.setLabelEdit(2,Response.data)
          this.showLabelEdit();
      })
    },
    /**
     *
     *
     * 客户标签列表
     *
     */
    getTagListCust(ID){
      this.$api.getTagListCust({salesId:this.$wxuserUtil.getUserId(),custId:this.custId}).then(Response=>{
        if(ID){
         this.label=this.setLabelEdit(1,Response.data)
        }else{
         this.label=this.setLabelEdit(1,Response.data).concat([{ name: "＋", edit: true }])
        }
      })
    },
    /**
     *
     *
     *  客户标签更新
     *
     */
    setSaveTag(delTag,addTag){
      this.$loading();
      this.$api.setSaveTag({
        salesId:this.$wxuserUtil.getUserId(),custId:this.custId,
        delTag:delTag,
        addTag:addTag,
        }).then(Response=>{
          if(Response.success==true){
              this.getTagListCust();
              this.$clear("更新成功");
          }else{
              this.$title("更新失败");
          }
          this.labelShow = false;
      })
    },
    /**
     *
     *  追加标签判断依据
     *
     */
    setLabelEdit(ID,DATA){
        if(Array.isArray(DATA)){
            for(let i=0;i<DATA.length;i++){
                if(DATA[i]){
                     if(ID==1){
                          DATA['edit']=false;
                     }
                     if(ID==2){
                         let $tagList =DATA[i]['tagList'];
                         for(let o=0;o<$tagList.length;o++){
                                   $tagList[o]['edit']=false;
                                   $tagList[o]['index']=i;
                                   $tagList[o]['background']="#373737";
                                   $tagList[o]['type']=0;
                         }
                     }
                }
            }
                          return DATA;
        }else{
           return [];
        }
    },
    /**
     *
     *
     *   初始化标签样式展示
     *
     */
    showLabelEdit(DATA){
        let $list_=[],$list_All=[],$pitchList=[];
         $list_    =  this.label;   //标签列表
         $list_All =  this.selectLabel;  //全部标签
         for(let i=0;i<$list_All.length;i++){
           let $tag  =  $list_All[i]['tagList'];
             if($tag){
                 for(let o=0;o<$tag.length;o++){
                       for(let k=0;k<$list_.length;k++){
                           if($tag[o]['id']==$list_[k]['tagId']){
                                this.pitchList.push($list_[k]['tagId']);
                                this.pitchLists.push($list_[k]['tagId']);
                                $tag[o]['edit']=true;
                                $tag[o]['background']='#E51C23';
                                $tag[o]['type']=1;
                           }else{

                           }
                       }
                 }
             }
         }
         this.selectLabel=$list_All;
    },
  },
  mounted() {
    this.hasModifyAuth = this.$wxuserUtil.hasFunAuthByRouteInst(this.$route,this.$funcKey.BasicModified);
    this.$wxuserUtil.initWxSdk()
    this.$refs.scrollView.style.height=localStorage.getItem('height')+'px';
        let $route_   =  this.$route;
        if($route_.query.custId){
          this.custId=$route_.query.custId;
          this.getCustDetail($route_.query.custId);
          if($route_.query.showID!=undefined){
          this.listIndex=$route_.query.showID;
          this.showMessageList(this.listIndex)
          if(this.listIndex==1){
             this.$refs.Inproduct.redact(1)
          }
          if(this.listIndex==2){

             if($route_.query.value=='qrcode'){
                this.$refs.ByProduct.scanQR()
             }else{
                this.$refs.ByProduct.redact(1)
             }
          }
          if(this.listIndex==3){
             this.$refs.FwNews.redact(1)
          }

          }
          // 判断是否有权限
          if($route_.query.showCC!=undefined){
             let Bl_  =  false;
              if($route_.query.showCC=="false"|| $route_.query.showCC==false){
                Bl_=false;
              }else{Bl_=true;}
              this.$refs.basicIf.authority(!Bl_)
              this.$refs.Inproduct.authority(!Bl_)
              this.$refs.ByProduct.authority(!Bl_)
              this.$refs.FwNews.authority(!Bl_)
            if(Bl_==false){
              this.getTagListCust()
            }else{
              this.getTagListCust(1);
            }
          }
          //跳转选项卡
          if($route_.query.index!=undefined&&$route_.query.index>=0&&$route_.query.index<=7){
            this.showMessageList($route_.query.index);
          }

        }else{
          this.$title("客户ID为空");
        }
        this.IdCode=this.$route.query.IdCode;
        var that=this;
      this.$wxuserUtil.getCurExternalChat(function (res) {
          that.chatId=res.chatId
      })
  },
  watch: {
  },
  created() {


  },
  components: {
    basicIf,
    Inproduct,
    ByProduct,
    FwNews,
    JnActivity,
    JnCurriculum,
    TheRecords,
    repairHis
  }
};
</script>

<style lang="less"  src="~p/pageView-clientDetails.less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/client/clientDetails.vue